export const DataModelPropertyDirection = {
	NONE: 0,
	IN: 1,
	OUT: 2,
	BOTH: 3,
};

export const DataModelSourceDirection = {
	IN: 1,
	OUT: 2,
	BOTH: 3,
};

export const DataModelTypes = {
	GuidType: {
		id: 0,
		name: 'GuidType',
		title: 'Guid',
	},
	StringType: {
		id: 1,
		name: 'StringType',
		title: 'String',
	},
	BoolType: {
		id: 2,
		name: 'BoolType',
		title: 'Bool',
	},
	DateType: {
		id: 3,
		name: 'DateType',
		title: 'Date',
	},
	IntType: {
		id: 4,
		name: 'IntType',
		title: 'Int',
	},
	LongType: {
		id: 24,
		name: 'LongType',
		title: 'Long',
	},
	FloatType: {
		id: 5,
		name: 'FloatType',
		title: 'Float',
	},
	DecimalType: {
		id: 6,
		name: 'DecimalType',
		title: 'Decimal',
	},
	TextType: {
		id: 7,
		name: 'TextType',
		title: 'Text',
	},
	ObjectReference: {
		id: 8,
		name: 'ObjectReference',
		title: 'Object Reference',
	},
	EnumReference: {
		id: 9,
		name: 'EnumReference',
		title: 'Enum Reference',
	},
	Fragment: {
		id: 10,
		name: 'Fragment',
		title: 'Fragment',
	},
	MultipleObjectReference: {
		id: 11,
		name: 'MultipleObjectReference',
		title: 'Multiple Object Reference',
	},
	Currency: {
		id: 12,
		name: 'Currency',
		title: 'Currency',
	},
	CurrencyCode: {
		id: 13,
		name: 'CurrencyCode',
		title: 'Currency Code',
	},
	ObjectType: {
		id: 14,
		name: 'ObjectType',
		title: 'Object',
	},
	ColorType: {
		id: 15,
		name: 'ColorType',
		title: 'Color Type',
	},
	HtmlType: {
		id: 16,
		name: 'HtmlType',
		title: 'Html Type',
	},
	Entity: {
		id: 22,
		name: 'Entity',
		title: 'Entity',
	},
	DataDefinition: {
		id: 23,
		name: 'DataDefinition',
		title: 'Data Definition',
	},
	Function: {
		id: 100,
		name: 'fn',
		title: 'Function',
	},
};
